/* Попап «Оберіть упаковку» (снипет cart-packages, макет Figma 2243:43052 / 2243:42959).
   Вибір - клік по плитці (рамка, рядок назва + ціна, підпис кнопки оновлюються),
   додавання - одна кнопка знизу. У кошик кладеться те саме, що й раніше:
   CartAPI.add([{ id: <варіант пакування>, quantity: 1 }], { source: 'cart-packages' }). */
(() => {
  const OPEN = 'is-open';
  const SOURCE = 'cart-packages';

  class CartPackages {
    constructor(modal) {
      this.modal = modal;
      this.track = modal.querySelector('[data-packages-track]');
      this.addBtn = modal.querySelector('[data-packages-add]');
      this.nameEl = modal.querySelector('[data-packages-name]');
      this.priceEl = modal.querySelector('[data-packages-price]');
      this.tpl = modal.dataset.addfor || '%PRICE%';

      this.modal.addEventListener('click', (e) => {
        if (e.target.closest('[data-packages-close]')) { this.close(); return; }
        const tile = e.target.closest('[data-packages-tile]');
        if (tile) {
          if (this.dragged) return;      // кінець перетягування мишею - не клік
          this.select(tile);
          return;
        }
        if (e.target.closest('[data-packages-add]')) this.add();
      });

      // стрілки ←/→ між плитками (radiogroup)
      this.track?.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const tiles = this.tiles();
        const i = tiles.indexOf(document.activeElement);
        if (i < 0) return;
        e.preventDefault();
        const next = tiles[Math.min(tiles.length - 1, Math.max(0, i + (e.key === 'ArrowRight' ? 1 : -1)))];
        next.focus();
        this.select(next);
      });

      this.bindScroll();

      this.unsubErr = window.PubSub?.subscribe?.(window.EVENTS?.cartError, ({ message, source }) => {
        if (source !== SOURCE) return;
        this.showError(message);
      });

      const sel = this.tiles().find((t) => t.classList.contains('is-selected')) || this.tiles()[0];
      if (sel) this.select(sel, false);
    }

    tiles() { return [...this.modal.querySelectorAll('[data-packages-tile]')]; }

    /* Гортання: тачпад і свайп - рідний горизонтальний скрол; звичайне колесо
       миші (вертикальне) переводимо в горизонталь; мишею можна тягнути. */
    bindScroll() {
      const t = this.track;
      if (!t) return;
      t.addEventListener('wheel', (e) => {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        const max = t.scrollWidth - t.clientWidth;
        if (max <= 0) return;
        const to = t.scrollLeft + e.deltaY;
        if ((to <= 0 && t.scrollLeft <= 0) || (to >= max && t.scrollLeft >= max)) return;
        e.preventDefault();
        t.scrollLeft = to;
      }, { passive: false });

      let x0 = 0; let s0 = 0; let down = false;
      t.addEventListener('pointerdown', (e) => {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        down = true; this.dragged = false; x0 = e.clientX; s0 = t.scrollLeft;
      });
      window.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - x0;
        if (!this.dragged && Math.abs(dx) < 5) return;
        this.dragged = true;
        t.classList.add('is-dragging');
        t.scrollLeft = s0 - dx;
      });
      window.addEventListener('pointerup', () => {
        if (!down) return;
        down = false;
        t.classList.remove('is-dragging');
        setTimeout(() => { this.dragged = false; }, 0);
      });
    }

    select(tile, scroll = true) {
      this.tiles().forEach((t) => {
        const on = t === tile;
        t.classList.toggle('is-selected', on);
        t.setAttribute('aria-checked', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.selected = tile;
      const price = tile.dataset.price || '';
      if (this.nameEl) this.nameEl.textContent = tile.dataset.title || '';
      if (this.priceEl) this.priceEl.textContent = price;
      if (this.addBtn) this.addBtn.textContent = this.tpl.replace('%PRICE%', price);
      if (scroll) tile.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }

    showError(message) {
      const box = this.modal.querySelector('[data-packages-error]');
      if (!box) return;
      box.textContent = message || window.themeStrings?.cartError || '';
      box.removeAttribute('hidden');
      clearTimeout(this.errTimer);
      this.errTimer = setTimeout(() => box.setAttribute('hidden', ''), 6000);
    }

    clearError() {
      const box = this.modal.querySelector('[data-packages-error]');
      if (!box) return;
      clearTimeout(this.errTimer);
      box.textContent = '';
      box.setAttribute('hidden', '');
    }

    open() {
      this.clearError();
      this.prevOverflow = document.body.style.overflow;
      this.modal.classList.add(OPEN);
      document.body.style.overflow = 'hidden';
      this.lastFocus = document.activeElement;
      // фокус у діалог (не на плитку, щоб не малювати рамку фокуса поверх вибору)
      const panel = this.modal.querySelector('.pkgSheet__panel');
      requestAnimationFrame(() => panel?.focus({ preventScroll: true }));
    }

    close() {
      if (!this.modal.classList.contains(OPEN)) return;
      this.clearError();
      this.modal.classList.remove(OPEN);
      document.body.style.overflow = this.prevOverflow || '';
      this.lastFocus?.focus?.({ preventScroll: true });
    }

    async add() {
      const btn = this.addBtn;
      const id = Number(this.selected?.dataset.variant);
      if (!id || !btn || btn.disabled) return;
      btn.disabled = true;
      this.clearError();
      try {
        await window.CartAPI.add([{ id, quantity: 1 }], { source: SOURCE });
        this.close();
      } catch (e) {
        // текст відмови від Shopify показує підписка на cartError; тут лише запасний
        const raw = e && e.data;
        if (!(raw && (raw.description || raw.message))) {
          this.showError(window.themeStrings?.cartError);
        }
      } finally {
        btn.disabled = false;
      }
    }
  }

  const getApi = () => {
    const modal = document.querySelector('[data-packages-modal]');
    if (!modal) return null;
    if (!modal.__packages) modal.__packages = new CartPackages(modal);
    return modal.__packages;
  };

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-packages-open]')) return;
    getApi()?.open();
  });

  // Escape закриває лише попап пакування, шухляда кошика під ним лишається відкритою
  window.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const m = document.querySelector('[data-packages-modal].' + OPEN);
    if (!m) return;
    e.stopPropagation();
    m.__packages?.close();
  }, true);
})();
